import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RuntimeService } from '../../shared/services/runtime.service';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const runtime = inject(RuntimeService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    router.navigate(['/load-planning']);
    return false;
  }

  if (runtime.IsDesktopApplication && !authService.hasLicence()) {
    router.navigate(['/verify-licence']);
    return false;
  }

  return true;
};
